<script>
  // Extensions
  import View from '@/views/View'

  // Mixins
  import LoadSections from '@/mixins/load-sections'

  export default {
    name: 'Klaim',

    metaInfo: { title: 'Klaim' },

    extends: View,

    mixins: [
      LoadSections([
        'hero-alt',
        'claim',
        'info',
      ]),
    ],

    props: {
      id: {
        type: String,
        default: 'claim',
      },
    },
  }
</script>
